'use client'

import { Button, Dialog, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { WalletConversionErrorModel } from 'types/models/business-account'

type Props = {
  error?: WalletConversionErrorModel
  onClose: () => void
}

const ErrorModal = ({ error, onClose }: Props) => {
  const translate = useTranslate('business.wallet.modal')

  if (!error) return null

  function getActions() {
    if (!error) return []

    const actions: ComponentProps<typeof Dialog>['actions'] = []

    if (error.buttonUrl && error.buttonTitle) {
      actions.push({
        text: error.buttonTitle,
        url: error.buttonUrl,
        style: Button.Styling.Filled,
      })
    }

    actions.push({
      text: translate('action.close'),
      callback: onClose,
      style: Button.Styling.Flat,
    })

    return actions
  }

  function renderBody() {
    return <Text as="span" html text={error?.body} />
  }

  return <Dialog show title={error.title} body={renderBody()} actions={getActions()} />
}

export default ErrorModal
